import React, { useRef, useState } from 'react';
import { Popover } from '@tempmee/react';
import { OutlineChevronDownIcon, OutlineChevronUpIcon } from '@tempmee/react-icons';
import { Colors } from '../../themes/colors';
import '../../themes/Button.scss';

export const TabItem = ({tab, value, onValueChanged} = {}) => {
    let isActive = value === tab.value || (!value && tab.default);
    const hasLinked = tab.linkedItems && tab.linkedItems.length > 0;

    const [isOpen, setIsOpen] = useState(false);
    const anchorRef = useRef(null);

    if (hasLinked) {
      isActive = tab.linkedItems.some((item) => item.value === value);

      return (
        <>
          <button
            ref={anchorRef}
            type="button"
            className="btn btn-info"
            onClick={() => setIsOpen((open) => !open)}
            aria-haspopup="menu"
            aria-expanded={isOpen}
            style={{
              backgroundColor: isActive ? Colors.secondary_500 : Colors.primary_500,
              border: 'none',
            }}
          >
            {/* The open/closed state is already on the button as
                `aria-expanded`, so the chevron is decorative. */}
            <span className="inline-flex items-center gap-1">
              {tab.label}
              {isOpen ? (
                <OutlineChevronUpIcon aria-hidden size={16} />
              ) : (
                <OutlineChevronDownIcon aria-hidden size={16} />
              )}
            </span>
          </button>

          <Popover
            open={isOpen}
            anchorEl={anchorRef.current}
            onClose={() => setIsOpen(false)}
            placement="bottom-start"
            surface="menu"
          >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <div
              role="menu"
              tabIndex={-1}
              aria-label={tab.label}
              onClick={() => setIsOpen(false)}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {tab.linkedItems.map((linkedItem) => (
                <button
                  key={linkedItem.value}
                  type="button"
                  role="menuitem"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '8px 16px',
                    fontSize: 14,
                    textAlign: 'left',
                    cursor: 'pointer',
                    color: Colors.neutral_800,
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f5f5f5'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  onClick={() => onValueChanged(linkedItem.value)}
                >
                  {linkedItem.label}
                </button>
              ))}
            </div>
          </Popover>
        </>
      );
    }

    return (
      <button
        className="btn btn-info"
        type="button"
        style={{
          backgroundColor: isActive ? Colors.secondary_500 : Colors.primary_500,
          border: 'none',
        }}
        onClick={() => onValueChanged(tab.value)}
      >
        {tab.label}
      </button>
    );
  }
